<template>
  <list-table
    :url="url"
    title="گزارش درگاه های زیر مجموعه"
    :fields="fields"
    :params="params"
    :btns="btns"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
export default {
  name: "SubGatewayReport",
  data() {
    return {
      url: "identifier-list",
      fields: [
        {
          key: "identifire",
          label: "معرف",
        },
        {
          key: "name",
          label: "نام پذیرنده",
        },
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "website",
          label: "آدرس وبسایت",
        },
        {
          key: "bess",
          label: "مجموع درآمد حاصل(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "beds",
          label: "درآمد تسویه شده(ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
            key: "btns",
            label: "جزییات",
          },
      ],
      params: [
          {
            label: "از تاریخ:",
            field: "dateFrom",
            type: "date-picker",
          },
          {
            label: "تا تاریخ:",
            field: "dateTo",
            type: "date-picker",
          },
          {
          label: "نام معرف:",
          field: "name",
          type: "text"
        },
        {
          label: "نام پذیرنده:",
          field: "nameAcceptor",
          type: "text"
        },
        {
          label: "وبسایت:",
          field: "websiteName",
          type: "text"
        },
        
      ],
      btns: [
          {
            icon: "eye",
            title: "جزییات",
            handler: (t) => {
             this.$router.push("/identifier/details/"+t.id);
            },
          },
      ]
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گزارش درگاه های زیر مجموعه" }]);
  },
  components: {
    "list-table": TableShowData,
  },
};
</script>